export default __webpack_public_path__ + "static/media/app-visual-1.a0476406.png";